import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, RoutesRecognized} from '@angular/router';
import {UserDataService} from '../../../../modules/auth/user-data.service';
import {CandidateDataService} from '../candidate-data.service';
import {NgForm} from '@angular/forms';
import {UploadService} from '../../../../shared/upload.service';
// import { Console } from 'console';
import { Router } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Component({
    selector: 'app-candidate-details',
    templateUrl: './application-profile.component.html',
    styleUrls: ['./application-profile.component.scss']
})
export class ApplicationProfileComponent implements OnInit {
    userData: any = [];
    profileIndex = ['1', '2', '3', '4', '12', '13', '14', '21', '23', '24', '31', '32', '34', '41', '42', '43', '124', '123', '234', '134']
    profilePicture: string;
    pdfFile;
    message;
    formResponse;
    formSent;
    videoCV: string;
    currentUserRoles;
    dataLoaded = false;
    userCanEdit = false;
    userRole='';
    backButtonUrl:string;
    previousUrl: string;


    constructor(private router: Router, private candidateDataService: CandidateDataService, private route: ActivatedRoute, private uploadService: UploadService) {
        this.uploadService.uploadFileSubject.subscribe(fileUploaded => {
            if (fileUploaded) {
                alert('Fisier incarcat cu succes.');
            } else {
                alert('Eroare la incarcare fisier.');
            }
        });

        
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.userData.id = params['id'];
            this.candidateDataService.getCandidateProfileData(this.userData.id).subscribe(resData => {
                this.userData = resData;
                console.log(this.userData);
                this.candidateDataService.getCurrentUserInfo().subscribe(data => {
                    // console.log("getCurrentUserInfo");
                    // console.log(data);
                    // this.currentUserRoles = data['roles'];
                    // console.log(this.currentUserRoles);
                    this.dataLoaded = true;

                    const role = this.currentUserRoles.filter(currentRole => {
                            if (currentRole === 'ROLE_recruiter_manager' || currentRole === 'ROLE_recruiter_operational' || currentRole === 'ROLE_recruiter_project_manager' || currentRole === 'ROLE_super_admin') {
                                this.userCanEdit = true;
                                console.log(this.userCanEdit);
                                return
                            }
                        }
                    )[0];

                    // if (role === 'client') {
                    //     this.backButtonUrl = '/aplicatii/' + this.userData.id;
                    //     console.log(this.backButtonUrl);
                    //     //this.pageTitle = `Aplicatie ${this.application.userFirstName} ${this.application.userLastName}`;
    
                    // } else {
                    //     this.backButtonUrl = '/aplicatie/' + '633163e0a8f8bc03eb753737';
                    //     console.log("butonuuuuuuuuul");
                    //     console.log(this.backButtonUrl);
                    //     //this.pageTitle = `Aplicatie ${this.application.applicationDetail.jobName}`;
                    // }

                })
                // if ((this.userData.profileImageId) === "defaultProfileImage.png") {
                //   this.profilePicture = this.basePath + "/agri/defaultProfileImage.png";
                // } else {
                //   this.profilePicture = this.basePath + "/agri/files/users/" + this.userData.id + "/userProfileImages/" + this.userData.profileImageId;
                // }
                //
                this.profilePicture = this.userData.profileImagePath;
                console.log('userdata', this.userData);

                this.videoCV = this.userData.linkVideoCV.replace('youtube.com/watch?v=', 'youtube.com/embed/')
            }, error => {
            });
        })
        
    }


    onSubmit(indexCandidate) {
        const indexCandidateObj= {
            indexJob: indexCandidate.form.value.indexJob,
            indexPerson: indexCandidate.form.value.indexPerson,
            matchingIndex: indexCandidate.form.value.matchingIndex.toString(),
            jobName: indexCandidate.form.value.jobName,
            discDescription: indexCandidate.form.value.discDescription
        }

        this.candidateDataService.updateIndexInformation(indexCandidateObj, this.userData.id).subscribe(result => {

            this.formResponse = !!result;
            this.formSent = true;

        }, error => {
            this.formResponse = false;
            this.formSent = true;
        })

    }

    uploadPDFAttachment(e, type) {
        this.pdfFile = e.target.files;
        this.uploadService.upload(this.pdfFile, '/uploadPDF?userId=' + this.userData.id + '&type=' + type);
    }
}
